import { Link, useLocation } from "wouter";
import { APP_NAME, APP_VERSION } from "@macroscope/shared";
import { SessionClock } from "./SessionClock";

const NAV = [
  { href: "/", label: "Dashboard" },
  { href: "/surprise", label: "Surprise" },
  { href: "/geopolitics", label: "Geopolitics" },
  { href: "/regime", label: "Regime" },
  { href: "/central-banks", label: "CBs" },
  { href: "/communication", label: "Comm" },
  { href: "/brief", label: "Brief" },
  { href: "/methodology", label: "Methodology" },
];

export function Layout({ children }: { children: React.ReactNode }) {
  const [location] = useLocation();

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-surface-2 bg-surface-1 px-4 py-3">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <Link href="/" className="flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded bg-macro-accent font-mono text-sm font-bold text-white">
              M
            </div>
            <div>
              <h1 className="text-lg font-semibold leading-none">{APP_NAME}</h1>
              <p className="text-xs text-slate-400">v{APP_VERSION}</p>
            </div>
          </Link>
          <div className="flex flex-wrap items-center gap-3">
            <SessionClock />
            <nav className="flex flex-wrap gap-1">
              {NAV.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className={`rounded-lg px-3 py-1.5 text-xs font-medium transition-colors ${
                    location === item.href
                      ? "bg-macro-accent/10 text-macro-accent"
                      : "text-slate-400 hover:bg-surface-2 hover:text-slate-200"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </header>

      <main className="flex-1 px-4 py-6">{children}</main>

      <footer className="border-t border-surface-2 bg-surface-1 px-4 py-3 text-center text-xs text-slate-500">
        Educational context only. Not financial advice. Data may be delayed or modeled.
      </footer>
    </div>
  );
}
